import { NavLink  } from 'react-router-dom';

export default function NavClient() {
  	return (
        <div className="nav-align-top">
            <ul className="nav nav-pills flex-column flex-md-row mb-6">
                <li className="nav-item">
                    <NavLink to="/client" className="nav-link">
                        <i className="bx me-1_5 bx-group bx-md"></i>
                        Elenco
                    </NavLink>
                </li>
                {/*
                <li className="nav-item">
                    <NavLink to="/" className="nav-link">
                        <i className="bx bx-stats bx-md"></i>
                        Statistiche
                    </NavLink>
                </li>
                 */}
            </ul>
        </div>
	);
}